import React from 'react';

export function DirectorySummary({ listing }) {
  const initials = String(listing.displayName || '').split(/\s+/).map(part => part[0]).slice(0, 2).join('');
  return <>
    <div className="flex gap-4 items-start">
      <div aria-hidden="true" className="w-12 h-12 shrink-0 rounded-full bg-[#F1E2D0] text-[#8B3A3A] flex items-center justify-center font-bold">{initials}</div>
      <div className="min-w-0">
        <h3 className="text-xl font-bold text-[#6B2B2B] break-words">{listing.displayName}</h3>
        <p className="text-sm text-[#6B2B2B]">{listing.professionalField}{listing.specialty ? ` · ${listing.specialty}` : ''}</p>
        <p className="text-sm text-[#6B2B2B]">{listing.state}{listing.yearsExperience !== null && listing.yearsExperience !== '' && listing.yearsExperience !== undefined ? ` · ${listing.yearsExperience} years experience (self-reported)` : ''}</p>
      </div>
    </div>
    <p className="mt-3 text-xs text-gray-600">Professional information is self-reported. Credentials have not been verified.</p>
  </>;
}
export default function DirectoryCard({ listing, onOpen }) {
  return <article className="bg-white rounded-lg p-5 border border-[#E6D5C1] shadow-sm">
    <DirectorySummary listing={listing} />
    <p className="text-[#6B2B2B] mt-3 line-clamp-2 break-words">{listing.bio}</p>
    <button type="button" onClick={() => onOpen(listing.id)} className="mt-4 px-5 py-2 rounded-lg bg-[#8B3A3A] text-white">View directory profile</button>
  </article>;
}
